import { combineReducers } from 'redux'
import fundingRoundReducer from './fundingRoundReducer'
import userReducer from './userReducer'


export default combineReducers({
    userReducer,
    fundingRoundReducer,

})
